import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Login } from "./Login";
import ZipUpload from "./ZipUpload";
import { UserConsole } from "./UserConsole";
import TemplateCreator from "./TemplateCreator";
import TemplateEditor from "./TemplateEditor";
import MyTemplates from "./MyTemplates";
import { Admin } from "./Admin";
import { UserProvider } from "./UserProvider";
import { OutreachProfileList } from "./OutreachProfileList";
import InspireDash from "./InspireDash";
import { PrettyConversation } from "./PrettyConv";
import { TCALinks } from "./TCALinks";
import QuoteTemplateCreator from "./QuoteTemplateCreator";
import QuotesPromptEditor from "./QuotesPromptEditor";

export function MyRoutes() {
    return (
      <UserProvider>
        <Router basename="/">
          <Routes>
            <Route path="/template/:templateId" element={<TemplateEditor />} />
            <Route path="/create-template" element={<TemplateCreator />} />
            <Route path="/create-quote-template" element={<QuoteTemplateCreator />} />
            <Route path="/quote-prompts" element={<QuotesPromptEditor />} />
            <Route path="/template/upload/" element={<ZipUpload />} />
            <Route path="/" element={<MyTemplates />} />
            <Route path="/outreach" element={<OutreachProfileList />} />
            <Route path="/inspire" element={<InspireDash />} />
            <Route path="/tca" element={<TCALinks />} />
           

            <Route path="/pretty-conversation/:conversationId" element={<PrettyConversation />} />


            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/users" element={<UserConsole />} />

            <Route path="/login" element={<Login />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}
